"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logErrorToNR = void 0;
var tslib_1 = require("tslib");
var index_1 = tslib_1.__importDefault(require("../modules/newRelic/index"));
var index_2 = require("../index");
var logErrorToNR = function (error, internalRequestPayload) {
    index_1.default.logError({
        component: "Pricing-SDK",
        componentVersion: index_2.version,
        errorMessage: JSON.stringify(error),
        additional: "Error Decorate Promise"
    }, internalRequestPayload);
};
exports.logErrorToNR = logErrorToNR;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/API/LogError.js
// module id = 3407
// module chunks = 11